import BaseDocument from '../../Model/BaseDocument';
import CollectionName from '../../utils/collections';

/**
 * LeadConfig model for handling lead configuration settings
 *
 * @class LeadConfig
 * @extends BaseDocument
 */
class LeadConfig extends BaseDocument {
  constructor(opts) {
    super(CollectionName.LEAD_CONFIG, opts);
  }

  /**
   * Get the discount offer configuration
   * @returns {object} The discount offer configuration
   */
  get discountOfferConfig() {
    return this.data?.discountOfferConfig || {};
  }

  /**
   * Get the initial discount percentage
   * @returns {number} The initial discount percentage (e.g., 25 for 25%)
   */
  get initialDiscountPercentage() {
    return this.discountOfferConfig.initialDiscountPercentage;
  }

  /**
   * Get the initial subscription months for discounted offers
   * @returns {number} The number of months for the initial subscription
   */
  get initialSubscriptionMonths() {
    return this.discountOfferConfig.initialSubscriptionMonths;
  }

  /**
   * Get the applicable user ratio for random selection
   * @returns {number} The ratio between 0 and 1 (e.g., 0.5 for 50%)
   */
  get applicableUserRatio() {
    return this.discountOfferConfig.applicableUserRatio;
  }

  /**
   * Get the country restrictions configuration
   * @returns {object} The country restrictions configuration
   */
  get countryRestrictions() {
    return this.data?.countryRestrictions || {};
  }

  /**
   * Get the globally allowed countries list
   * @returns {string[]} Array of allowed country names
   */
  get allowedCountries() {
    return this.countryRestrictions.allowed || [];
  }

  /**
   * Check if discount offers are enabled
   * @returns {boolean} True if discount offers are configured
   */
  get isDiscountOffersEnabled() {
    return this.exists
      && !!this.initialDiscountPercentage
      && !!this.initialSubscriptionMonths
      && !!this.applicableUserRatio;
  }
}

export default LeadConfig;
